import React from "react";
import { useLocation, useParams } from "react-router-dom";
import Documents from "../../clients/components/Documents";
import BackButton from "../../../components/button/BackButton";

const ViewDocuments = () => {
  const { id } = useParams();
  const { state } = useLocation();

  return (
    <div className="bg-white rounded-lg border border-1">
      <div className="flex items-center gap-3 p-4">
        <BackButton />
        <p className="title capitalize">
          {state?.client || "Client"}'s Documents
        </p>
      </div>

      <Documents id={id} />
    </div>
  );
};

export default ViewDocuments;
